import { useState } from "react";
import { useUpdateFavoriteMutation } from "../../../../../features/contactsApi";
import { addBannerWithTimeout } from "../../../../lib/centralizedBanner/slice";
import { keycloak } from "../../../../lib/keycloak";
import { useAppDispatch } from "../../../../lib/redux/hooks";
import { StarIcon } from "../../../../ui/icons/star";
import Button from "../../../../ui/molecules/button";
import { Spinner } from "../../../../ui/molecules/spinner";

interface Props {
    contactId: string;
    favorite: boolean;
}
export function Favorite({ contactId, favorite }: Props) {
    const dispatch = useAppDispatch();

    const [isClicked, setIsClicked] = useState(false);
    const [updateFavorite, { isLoading }] = useUpdateFavoriteMutation();

    const handleUpdateFavorite = async () => {
        try {
            await updateFavorite({ contactId, favorite: !favorite }).unwrap();
            dispatch(addBannerWithTimeout({
                message: 'Preferito aggiornato con successo.',
                variant: 'success'
            }))
        } catch (error) {
            dispatch(addBannerWithTimeout({
                message: 'Errore durante l\'aggiornamento del preferito.',
                variant: 'error'
            }))
        } finally {
            setIsClicked(false);
        }
    }

    return (
        isLoading && isClicked ? (
            <div className="w-10 flex items-center justify-center">
                <Spinner size={20} />
            </div>
        ) : (
            <Button
                icon={<StarIcon active={favorite} color={""} size={0} />}
                size={"md"}
                iconPosition={"only"}
                disabled={keycloak.hasRealmRole('customer') || keycloak.hasRealmRole('collaborator')}
                variant={"link"}
                color={"gray"}
                onClick={() => {
                    handleUpdateFavorite();
                }}
            />
        )
    )
}